<!--
 * @Author: 汪俊洪
 * @Date: 2021-10-08 19:00:07
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2024-02-28 15:42:59
 * @Description: 商品信息
-->
<template>
  <div>
    <h2 class="title">
      <div class="left required">
        开票明细：
        <el-checkbox v-model="checked" v-if="companyId"
          >剔除已全部开票明细</el-checkbox
        >
      </div>
      <el-form
        class="invoicing-details"
        :inline="true"
        :model="dataForm"
        v-if="companyId"
      >
        <el-form-item label="">
          <el-input
            clearable
            v-model="dataForm.goodsCode"
            @clear="doSearch"
            placeholder="商品编号"
          ></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-input
            clearable
            @clear="doSearch"
            v-model="dataForm.goodsName"
            placeholder="商品名称模糊"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="doSearch">查询</el-button>
          <el-button
            type="primary"
            @click="handlerAdd"
            size="small"
            v-if="invoiceApplyOrderVoList.length"
            >新增明细</el-button
          >
          <!-- <el-button type="primary" size="small" @click="handlerExport">导出明细</el-button> -->
          <el-button type="primary" size="small" @click="handlerImport">批量导入</el-button>
        </el-form-item>
      </el-form>
      <div v-show="showList.length > 0">
        <!-- <el-input-number
          style="width: 100px; margin-right: 12px"
          v-model="coefficient"
          :controls="false"
          placeholder="乘以"
          :precision="2"
          :step="0.1"
          :min="0.01"
          :max="1"
        ></el-input-number>
        <el-button @click="batchSet" size="small" type="primary">批量设置</el-button> -->
      </div>
    </h2>
    <el-table
      :data="pageList"
      :summary-method="getSummaries"
      show-summary
      border
      style="width: 100%"
    >
      <el-table-column type="index" width="50" align="center" label="序号">
        <template slot-scope="scope">
          {{ page.limit * (page.page - 1) + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column
        prop="orderCode"
        header-align="center"
        align="center"
        label="订单编号"
      >
      </el-table-column>
      <el-table-column
        prop="goodsCode"
        header-align="center"
        align="center"
        label="商品编码"
      >
      </el-table-column>
      <el-table-column
        prop="goodsName"
        header-align="center"
        align="center"
        width="160px"
        label="商品名称"
      >
        <!-- <template slot-scope="scope">
          <span class="disabled-span" v-if="!scope.row.waitInvoiceAmount">{{
            scope.row.goodsName
          }}</span>
          <div v-else class="show-limit-wrap" :class="{ red: getByteLen(scope.row.goodsName) > 82 }">
            <el-input
              v-model="scope.row.goodsName"
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 4}"
              :maxlength="getByteLen(scope.row.goodsName) >= 82 ? scope.row.goodsName.length : 82"
            />
            <span class="show-limit">
              {{getByteLen(scope.row.goodsName)}}/82
            </span>
          </div>
        </template> -->
      </el-table-column>
      <el-table-column
        prop="goodsModel"
        header-align="center"
        align="center"
        label="型号"
        width="160px"
      >
        <!-- <template slot-scope="scope">
          <span class="disabled-span" v-if="!scope.row.waitInvoiceAmount">{{
            scope.row.goodsModel
          }}</span>
          <div v-else class="show-limit-wrap" :class="{ red: getByteLen(scope.row.goodsModel) > 40 }">
            <el-input
              v-model="scope.row.goodsModel"
              :autosize="{ minRows: 2, maxRows: 4}"
              type="textarea"
              :maxlength="getByteLen(scope.row.goodsModel) >= 40 ? scope.row.goodsModel.length : 40"
            >
            </el-input>
            <span class="show-limit">{{getByteLen(scope.row.goodsModel)}}/40</span>
          </div>
        </template> -->
      </el-table-column>
      <el-table-column
        prop="goodsUnit"
        header-align="center"
        align="center"
        label="单位"
        width="80"
      >
        <!-- <template slot-scope="scope">
          <span class="disabled-span" v-if="!scope.row.waitInvoiceAmount">{{
            scope.row.goodsUnit
          }}</span>
          <el-input v-else v-model="scope.row.goodsUnit" :maxlength="10" />
        </template> -->
      </el-table-column>
      <el-table-column
        prop="goodsNum"
        header-align="center"
        align="center"
        width="110px"
        label="已开/全部数量"
      >
        <template slot-scope="scope">
          {{ scope.row.hasInvoiceNum }} /
          {{ scope.row.goodsNum }}
        </template>
      </el-table-column>
      <el-table-column
        prop="goodsMoney"
        header-align="center"
        align="center"
        width="150px"
        label="已开/全部金额"
      >
        <template slot-scope="scope">
          {{ scope.row.hasInvoiceAmount }} /
          {{ scope.row.goodsMoney }}
        </template>
      </el-table-column>
      <!-- <el-table-column
        header-align="center"
        align="right"
        prop="goodsMoney"
        label="含税总价"
        width="120"
      >
        <template slot-scope="scope">
          {{ scope.row.goodsMoney | formatePriceNormal }}
        </template>
      </el-table-column> -->
      <!-- <el-table-column
        prop="taxRate"
        header-align="center"
        align="center"
        label="税率"
        width="80"
      >
        <template slot-scope="scope"> {{ scope.row.taxRate * 100 }}% </template>
      </el-table-column> -->
      <el-table-column
        prop="invoiceNum"
        header-align="center"
        align="center"
        label="本次开票数量"
        width="110"
      >
        <template slot-scope="scope">
          <span class="disabled-span" v-if="!scope.row.waitInvoiceAmount"
            >已开全部</span
          >
          <el-input-number
            v-else
            v-model="scope.row.invoiceNum"
            @blur="() => changeValue('invoiceNum', scope.row)"
            style="width: 85px !important"
            :controls="false"
            :max="99999999"
            :min="1/Math.pow(10, 3)"
            :placeholder="`3位小数`"
            :precision="3"
            maxlength="10"
          ></el-input-number>
        </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="right"
        label="含税单价"
        width="120"
      >
        <template slot-scope="scope">
          {{ scope.row.transactionPrice | formatePriceNormal }}
        </template>
      </el-table-column>
      <el-table-column
        prop="invoiceAmount"
        header-align="center"
        align="center"
        label="本次开票金额"
        width="150"
      >
        <template slot-scope="scope">
          <span class="disabled-span" v-if="!scope.row.waitInvoiceAmount"
            >已开全部</span
          >
          <el-input-number
            v-else
            style="width: 125px !important"
            v-model="scope.row.invoiceAmount"
            @blur="() => changeValue('invoiceAmount', scope.row)"
            :controls="false"
            :min="0.01"
            :max="scope.row.waitInvoiceAmount"
            :precision="2"
            maxlength="10"
            placeholder="本次开票金额"
          ></el-input-number>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        header-align="center"
        align="center"
        label="操作"
      >
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="deleteHandle(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page.page"
      :page-sizes="[10, 20, 50, 100, 200]"
      :page-size="page.limit"
      :pager-count="5"
      layout="total, sizes, prev, pager, next, jumper"
      :total="showList.length"
    >
    </el-pagination>
    <UploadFile
      :limit="1"
      :accept="batchSearchInfo.accept"
      :size="batchSearchInfo.size"
      :url="batchSearchInfo.url"
      :downUrl="batchSearchInfo.downUrl"
      :dialogVisible.sync="batchSearchInfo.dialogVisible"
      :extra="batchSearchInfo.extra"
      v-if="batchSearchInfo.dialogVisible"
      @fileSuccess="onSuccess"
    >
      <div slot="tip" class="el-upload__tip">
        只能上传xls、xlsx文件，限100MB
      </div>
      <div slot="other" class="other">
        已选择： {{ detail.companyCode }} {{ detail.companyName }}
      </div>
    </UploadFile>
    <el-dialog title="批量新增" :visible.sync="dialogVisible" width="800px">
      <UploadTable
        v-if="dialogVisible"
        :uploadInfo="uploadInfo"
        @cancel="dialogVisible = false"
        @confirm="confirmAddUpload"
      />
    </el-dialog>
  </div>
</template>

<script>
import { formatePrice } from '@/utils/formatePrice'
import tableTotal from '@/utils/tableTotal'
import { tableToExcel } from '@/utils/tableToExcel'
import UploadFile from './upload.vue'
import UploadTable from './uploadTable.vue'
export default {
  components: {
    UploadFile,
    UploadTable
  },
  filters: {
    formatePrice (val) {
      if (val) {
        return formatePrice(val.toFixed(2))
      }
      return '0.00'
    },
    formatePriceNormal (val) {
      if (val) {
        return formatePrice(val)
      }
      return '0.00'
    }
  },
  props: {
    companyId: {
      type: String,
      default: () => ''
    },
    list: {
      type: Array,
      default: function () {
        return []
      }
    },
    invoiceApplyOrderVoList: {
      type: Array,
      default: function () {
        return []
      }
    },
    orderCodeList: {
      type: Array,
      default: function () {
        return []
      }
    },
    detail: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    const url = this.$getDictLabel('OMS_EXCELL_IMPORT_TYPE', '10')
    return {
      tableTotal: {
        含税总价: '',
        本次开票金额: '',
        本次开票数量: ''
      },
      checked: true,
      coefficient: undefined,
      page: {
        page: 1, // 第几页
        limit: 20 // 一页多少条
      },
      pageList: [], // 分页数据
      dataList: [], // 这是完整数据
      showList: [], // 要显示的数据
      batchSearchInfo: {
        dialogVisible: false,
        accept: '.xlsx,.xls',
        downUrl: [
          {
            name: '批量导入模板.xlsx',
            url
          }
        ],
        extra: {
          exportType: {
            value: 1
          }
        },
        size: 100
      },
      dataForm: {
        goodsCode: '',
        goodsName: ''
      },
      dialogVisible: false,
      uploadInfo: {},
      loading: false
    }
  },
  watch: {
    list: {
      handler () {
        this.checked = true
        this.setDataList()
      },
      immediate: true
    },
    checked () {
      this.setShowList()
    }
  },
  methods: {
    setPageList (isReset = false) {
      // 重新赋值的列表从第一页开始
      isReset && (this.page.page = 1)
      const start = (this.page.page - 1) * this.page.limit
      const end = this.page.page * this.page.limit
      console.log(this.showList, start, end)
      this.pageList = this.showList.slice(start, end)
    },
    // 分页 页码
    handleCurrentChange (val) {
      this.page.page = val
      // 刷新列表数据
      this.setPageList()
    },
    // 分页 每页多少条改变
    handleSizeChange (val) {
      this.page.page = 1
      this.page.limit = val
      // 刷新列表数据
      this.setPageList()
      scrollTo(0, 500)
    },
    // 设置数据
    setDataList () {
      if (this.dataList.length) {
        const obj = {}
        this.dataList.forEach((v) => {
          obj[v.orderCode + '-' + v.goodsCode] = v
        })
        const list = [...this.list]
        list.forEach((v) => {
          // 保留之前填写的内容
          const item = obj[v.orderCode + '-' + v.goodsCode]
          if (item) {
            v.invoiceNum = item.invoiceNum
            v.invoiceAmount = item.invoiceAmount
          }
        })
        this.dataList = [...list]
      } else {
        this.dataList = [...this.list]
      }
      this.setShowList()
      this.setPageList(true)
    },
    // 隐藏开票完的
    setShowList () {
      if (this.checked) {
        this.showList = this.filter(this.dataForm, [...this.dataList])
        console.log(this.showList)
      } else {
        // 如果要显示已开过的
        this.selectIsHasAllInvoice((data) => {
          this.showList = this.filter(this.dataForm, [
            ...this.dataList,
            ...data
          ])
        })
      }
      this.setPageList(true)
    },
    // 查看已开票的数据
    selectIsHasAllInvoice (call) {
      const orderCodeList = []

      this.invoiceApplyOrderVoList.forEach((v) => {
        if (!orderCodeList.includes(v.orderCode)) {
          orderCodeList.push(v.orderCode)
        }
      })
      // 没有orderCode 不调接口
      if (!orderCodeList.length) {
        return
      }
      const obj = {
        orderCodeList
      }
      this.$http
        .post('/front/oms/shopping/invoiceApply/orderItem/list/hasInvoiceAll', obj)
        .then(({ data: res }) => {
          if (res.code === 0) {
            call && call(res.data)
          }
        })
    },
    // 表格底部合计
    getSummaries (param) {
      return tableTotal(param, this.tableTotal)
    },
    deleteHandle (row) {
      this.dataList.some((v, i) => {
        if (v.goodsCode === row.goodsCode && v.orderCode === row.orderCode) {
          this.dataList.splice(i, 1)
          this.$emit('deleteHandle', i)
          return true
        }
        return false
      })
    },
    // 修改开票数据
    changeValue (prop, row) {
      const obj = {
        orderCode: row.orderCode,
        goodsCode: row.goodsCode,
        invoiceApplyNo: row.invoiceApplyNo, // 发票号
        [prop]: row[prop],
        goodsMoney: row.goodsMoney,
        transactionPrice: row.transactionPrice
      }
      if (this.loading) {
        return
      }
      this.loading = true
      this.$http
        .post('/front/oms/shopping/invoiceApply/confirmInvoiceOrderItemByGoodsCode', obj)
        .then(({ data: res }) => {
          this.loading = false
          if (res.code !== 0) {
            return
          }
          row.invoiceNum = res.data.invoiceNum
          row.invoiceAmount = res.data.invoiceAmount
          this.$emit('setInvoiceOrderMoney', this.dataList)
        })
    },
    // 批量设置
    batchSet () {
      if (!this.coefficient) {
        this.$message.warning('请输入系数')
        return
      }
      const itemList = []
      this.dataList.forEach((v) => {
        if (v.waitInvoiceAmount) {
          itemList.push({
            orderCode: v.orderCode,
            goodsMoney: v.goodsMoney,
            goodsNum: v.goodsNum,
            hasInvoiceAmount: v.hasInvoiceAmount,
            hasInvoiceNum: v.hasInvoiceNum,
            goodsCode: v.goodsCode,
            transactionPrice: v.transactionPrice
          })
        }
      })
      if (itemList.length === 0) {
        this.$message.warning('没有需要设置的开票明细')
        return
      }
      const obj = {
        itemList,
        invoiceNum: this.detail.invoiceNum,
        invoiceApplyNo: this.detail.invoiceApplyNo,
        coefficient: this.coefficient || 1 // 系数 0-1
      }
      this.$http
        .post('/front/oms/shopping/invoiceApply/invoiceOrderItem/list/batchSet', obj)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return
          }
          const obj = {}
          res.data.forEach((v) => {
            obj[v.orderCode + '-' + v.goodsCode] = v
          })
          const list = [...this.list]
          list.forEach((v) => {
            // 保留之前填写的内容
            const item = obj[v.orderCode + '-' + v.goodsCode]
            if (item) {
              v.invoiceNum = item.invoiceNum
              v.invoiceAmount = item.invoiceAmount
            }
          })
          this.dataList = [...list]
          this.coefficient = undefined
          this.$emit('setInvoiceOrderMoney', this.dataList)
        })
    },
    handlerAdd () {
      this.$emit('handlerAdd')
    },
    handlerExport () {
      if (this.list.length === 0) {
        this.$message.warning('没有要导出的内容')
        return
      }
      const data = this.list.map((i) => {
        return {
          ...i,
          goodsNumTotal: `${i.hasInvoiceNum}/${i.goodsNum}&nbsp;`,
          amountTotal: `${i.hasInvoiceAmount}/${i.goodsMoney}&nbsp;`,
          taxRateStr: `${i.taxRate * 100}%`,
          taxCode: i.taxCode ? `${i.taxCode}&nbsp;` : ''
        }
      })

      const titles = {
        orderCode: '所属订单号',
        goodsCode: '商品编码',
        goodsName: '商品名称',
        goodsModel: '型号',
        goodsUnit: '单位',
        goodsNumTotal: '已开/全部数量',
        amountTotal: '已开/全部金额',
        transactionPrice: '含税单价',
        goodsMoney: '含税总价',
        taxRateStr: '税率',
        invoiceNum: '本次开票数量',
        invoiceAmount: '本次开票金额',
        taxCode: '税收编码',
        taxName: '税收名称'
      }
      tableToExcel({ data, titles, fileName: '开票明细导出.xls' })
    },
    handlerImport () {
      this.batchSearchInfo.dialogVisible = true
    },
    onSuccess (bool, val) {
      const obj = {
        companyId: this.companyId,
        invoiceApplyOrderItemVoList: this.list,
        ossId: val.data ? val.data.aliOssId : '',
        orderCodeList: this.orderCodeList,
        invoiceType: this.detail.invoiceType,
        invoiceApplyNo: this.detail.invoiceApplyNo || undefined
      }

      this.$http
        .post('/front/oms/shopping/invoiceApply/import', obj)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return
          }
          this.batchSearchInfo.dialogVisible = false
          this.uploadInfo = res.data
          this.dialogVisible = true
        })
    },
    // 确定添加导入的
    confirmAddUpload () {
      // 空值为更新的订单列表
      this.$emit('confirmAddUpload', this.uploadInfo.successItemVoList)
      this.dialogVisible = false
    },
    // 前端查询
    doSearch () {
      this.setShowList()
    },
    // 过滤数据
    filter (condition, data) {
      return data.filter((item) => {
        return Object.keys(condition).every((key) => {
          return String(item[key])
            .toLowerCase()
            .includes(String(condition[key]).trim().toLowerCase())
        })
      })
    },
    getByteLen (str) { // 传入一个字符串
      // eslint-disable-next-line no-control-regex
      return str.replace(/[^\x00-\x7f]/g, '  ').length
    },
    async validate () {
      if (this.loading) {
        this.$message.warning('开票信息计算中，请重新保存')
        return false
      }
      const res = this.dataList.some((v, i) => {
        if (!v.goodsName) {
          this.$message.warning(`第${i + 1}条商品名称不能为空`)
          return true
        }
        if (this.getByteLen(v.goodsName) > 82) {
          this.$message.warning(`第${i + 1}条商品名称不能超过82个字符`)
          return true
        }
        if (!v.goodsModel) {
          this.$message.warning(`第${i + 1}条型号不能为空`)
          return true
        }
        if (this.getByteLen(v.goodsModel) > 40) {
          this.$message.warning(`第${i + 1}条型号不能超过40个字符`)
          return true
        }
        if (!v.invoiceNum) {
          this.$message.warning(`第${i + 1}条本次开票数量不能为空`)
          return true
        }
        if (!v.invoiceAmount) {
          this.$message.warning(`第${i + 1}条本次开票金额不能为空`)
          return true
        }
        return false
      })
      return !res
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  display: flex;
  justify-content: space-between;
}
.left {
  margin: 0 0 16px;
  height: 20px;
  font-weight: 700;
  font-size: 14px;
  color: #303133;
  line-height: 20px;
  &::before {
    content: '*';
    color: transparent;
  }
  &.required::before {
    color: #f00;
  }
}

.disabled-span {
  display: block;
  padding: 8px;
  background: rgb(242, 242, 242);
  border-radius: 4px;
  color: #7f7f7f;
}

.invoicing-details {
  flex: 1;
  padding-left: 12px;
}

.other {
  font-size: 18px;
  padding-bottom: 12px;
  color: #000;
}

.show-limit-wrap {
  position: relative;
  &.red {
    .show-limit{
      color: rgb(248, 27, 27);
    }
    ::v-deep .el-textarea__inner {
      border-color: rgb(248, 27, 27);
    }
  }
  .show-limit {
    color: #909399;
    background: #FFFFFF;
    position: absolute;
    font-size: 12px;
    bottom: 5px;
    right: 10px;

  }
}
</style>
